/**
 * FDVRouter — Point d'entree du formulaire de declaration de vente (FDV).
 * Rend le formulaire dynamiquement a partir du template JSON actif de la filiale
 * (agency_settings / fdv_templates), via FDVDynamicRenderer.
 */
import FDVDynamicRenderer from './FDVDynamicRenderer';

export default function FDVRouter() {
  return <FDVDynamicRenderer />;
}
